var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicFactCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 9,
    fill: "#E7F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 45.4922V15.62C19 13.6202 20.6211 11.9991 22.6209 11.9991H44.2983C45.2188 11.9991 45.9649 12.7453 45.9649 13.6657V42.3141",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6211 19.0841V42.3125",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45.9453V15.6219C19 13.6225 20.6215 12.0018 22.6217 12.0018V15.9753",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4199 49.5625H22.6208C20.621 49.5625 19 47.9415 19 45.9417V45.9346C19 43.935 20.621 42.3139 22.6208 42.3139H45.9649V47.8959C45.9649 48.8163 45.2188 49.5625 44.2983 49.5625H27.3575",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3595 51.7085L24.4219 53V45.9395H27.3595V51.7085Z",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6211 45.9375H37.3163",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5625 45.9062H45.9633",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6445 30.5102C25.6445 32.2586 27.0626 33.6761 28.812 33.6761H28.8504C28.8504 35.4245 30.2685 36.8419 32.0178 36.8419H32.0563V36.9462C32.0563 37.77 32.5785 38.4861 33.3447 38.7897C33.853 38.9912 34.2281 39.392 34.2809 40.0898C34.2809 39.3808 34.668 38.985 35.1832 38.7873C35.9846 38.4795 36.5055 37.7001 36.5055 36.8419H36.544C38.2933 36.8419 39.7114 35.4245 39.7114 33.6761H39.7499C41.4992 33.6761 42.9172 32.2586 42.9172 30.5102V24.0088C42.9172 22.2605 41.4992 20.843 39.7499 20.843H39.7114C39.7114 19.0945 38.2933 17.6771 36.544 17.6771H36.5055C36.5055 16.8189 35.9846 16.0395 35.1832 15.7318C34.668 15.534 34.2809 15.1382 34.2809 14.4292C34.2404 15.1403 33.8602 15.5377 33.3499 15.735C32.5596 16.0404 32.0563 16.8221 32.0563 17.669V17.6771H32.0178C30.2685 17.6771 28.8504 19.0945 28.8504 20.843H28.812C27.0626 20.843 25.6445 22.2605 25.6445 24.0088V30.5102Z",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2969 27.2581C39.2969 29.9805 37.0888 32.1875 34.3653 32.1875C31.6416 32.1875 29.4336 29.9805 29.4336 27.2581C29.4336 24.5357 31.6416 22.3287 34.3653 22.3287",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5664 22.9137V25.0938",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6576 24.0039H36.4766",
    stroke: "#3C81B9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicFactCardIcon);
export default __webpack_public_path__ + "static/media/basic-fact-card-icon.9cc524593db2b185ca20e1cd2d4e4eab.svg";
export { ForwardRef as ReactComponent };